exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3uG_ewwtP2KoixbZFiPjKq {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n  overflow-x: hidden;\n  height: 100%;\n}\n._3uG_ewwtP2KoixbZFiPjKq .i6C1QTJzBZeec8kUPpxUq {\n  display: flex;\n  flex: 1;\n  background-color: #fff;\n  padding: 0;\n  overflow: hidden;\n}\n._3uG_ewwtP2KoixbZFiPjKq .i6C1QTJzBZeec8kUPpxUq ._2lZYb9Hmx-vOpJpmMbYavg {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_3uG_ewwtP2KoixbZFiPjKq",
	"content": "i6C1QTJzBZeec8kUPpxUq",
	"pane": "_2lZYb9Hmx-vOpJpmMbYavg"
};